import { render, staticRenderFns } from "./addLegSub.vue?vue&type=template&id=12db6380&scoped=true&"
import script from "./addLegSub.vue?vue&type=script&lang=js&"
export * from "./addLegSub.vue?vue&type=script&lang=js&"
import style0 from "./addLegSub.vue?vue&type=style&index=0&id=12db6380&prod&scoped=true&lang=css&"
import style1 from "./addLegSub.vue?vue&type=style&index=1&id=12db6380&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12db6380",
  null
  
)

export default component.exports